import React from "react";
import CalendaryWeatherForecast from "../../nova-home/calendary";

const CalendaryNovaFarm = ({ codIBGE, location }) => {
  return (
    <CalendaryWeatherForecast
      codIBGE={codIBGE}
      location={location}
      showFarmSelector={false}
    />
  );
};

export default CalendaryNovaFarm;